module.exports = __webpack_public_path__ + "static/media/gob.e4be3844.PNG";